import { type LucideIcon, MessageCircleMore } from 'lucide-react';

export const CommentIcon: LucideIcon = MessageCircleMore;
